import { render, staticRenderFns } from "./recharge-scheme-add.vue?vue&type=template&id=351f8044&scoped=true&"
import script from "./recharge-scheme-add.vue?vue&type=script&lang=js&"
export * from "./recharge-scheme-add.vue?vue&type=script&lang=js&"
import style0 from "./recharge-scheme-add.vue?vue&type=style&index=0&id=351f8044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f8044",
  null
  
)

export default component.exports